import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { AiChatService, SuggestedPrompt } from '../../../services/ai-chat.service';
import { Subscription } from 'rxjs';

/**
 * Suggested Prompts Component
 * Displays context-aware suggested prompts as clickable chips
 */
@Component({
    selector: 'app-suggested-prompts',
    templateUrl: './suggested-prompts.component.html',
    styleUrls: ['./suggested-prompts.component.scss']
})
export class SuggestedPromptsComponent implements OnInit, OnDestroy {
    @Output() promptSelected = new EventEmitter<SuggestedPrompt>();

    public prompts: SuggestedPrompt[] = [];
    private subscriptions: Subscription[] = [];

    constructor(private aiChatService: AiChatService) { }

    ngOnInit(): void {
        // Subscribe to suggested prompts
        const promptsSub = this.aiChatService.suggestedPrompts$.subscribe(prompts => {
            this.prompts = prompts;
        });
        this.subscriptions.push(promptsSub);
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }

    /**
     * Handle prompt click - emits full prompt object with task identifier
     */
    public selectPrompt(prompt: SuggestedPrompt): void {
        this.promptSelected.emit(prompt);
    }

    /**
     * TrackBy function for ngFor performance
     */
    public trackByText(index: number, prompt: SuggestedPrompt): string {
        return prompt.text;
    }
}
